<script>
import axios from 'axios';
import PressReleaseCarousel from './PressReleaseCarousel.vue';

export default {
    components: {
        PressReleaseCarousel,
    },
    data() {
        return {
            items: [],
        };
    },
    methods: {
        getPressReleases() {
            axios.get('/api/articles/press-release').then((response) => {
                this.$data.items = response.data.pressReleases;
            });
        },
    },
    mounted() {
        this.getPressReleases();
    },
};
</script>

<template>
    <PressReleaseCarousel title="Press Release" :items="items">
    </PressReleaseCarousel>
</template>
